import styled, { css } from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;

export const HeaderWrapper = styled.div`
  background: #15aee5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.375rem;
`;

export const Title = styled.h2`
  font-size: 1.25rem;
  color: white;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  text-transform: initial;
`;
export const FormBody = styled.div`
  max-height: 60vh;
  padding: 0;
  overflow-y: auto;
`;
export const OptionsWrapper = styled.div`
  padding: 1rem 1.375rem;
`;
export const FlexRow = styled.div`
  display: flex;
  align-items: ${(props) => props.align ?? "center"};
  > div {
    margin-right: 1rem;
  }
`;
export const SectionContainer = styled.section`
  width: 100%;
`;

export const LineItemsGrid = styled.div`
  width: 100%;
  border-radius: 5px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
`;

export const LineItemsHeaderRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) =>
    props.column ?? "1.4fr 1.3fr 1.1fr 1.1fr 0.6fr 0.8fr 0.7fr"};
  align-items: left;
  background: #008395;
  gap: 12px;
  padding: 12px 16px;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) =>
    props.column ?? "1.4fr 1.3fr 1.1fr 1.1fr 0.6fr 0.8fr 0.7fr"};
  gap: ${(props) => props.gap ?? "12px"};
  padding: ${(props) => props.padding ?? "12px 16px"};
  border-bottom: ${(props) => props.border ?? "1px solid #e5e5e5"};
  background: ${(props) => props.color ?? "#fff"};
`;


export const LineItemsHeaderCell = styled.div`
  font-family: Lato;
  font-size: 0.8125rem;
  font-weight: 700;
  color: #fff;
`;

export const NoLineItemsMessage = styled.p`
  color: #767676;
  font-family: Lato;
  font-size: 0.875rem;
  font-style: italic;
  margin: 10px 0;
`;

export const JobsiteRow = styled.div`
  background-color: ${(props) => props.backgroundColor ?? "#00839533"};
  color: ${(props) => props.color ?? "#0a4986"};
  padding: 8px 12px;
  font-family: Lato;
  font-size: 0.9375rem;
  font-weight: 700;
`;

export const GridCell = styled.div`
  font-family: "Lato";
  font-size: ${(props) => props.fontSize ?? "0.875rem"};
  color: ${(props) => props.color ?? "#474747"};
  word-break: break-word;
  align-content: center;
  font-weight: ${(props) => props.fontWeight ?? "400"};
  font-style: ${(props) => props.fontStyle ?? "normal"};
  text-align: ${(props) => props.textAlign ?? "left"};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.375rem;
  border-top: 1px solid #ececec;
`;

export const SectionTitle = styled.h3`
  font-family: Lato;
  font-size: 1.125rem;
  font-weight: 700;
  color: #0a4986;
  margin: ${(props) => props.margin ?? "0 0 10px 0"};
  padding-bottom: ${(props) => props.paddingBottom ?? "8px"};
  border-bottom: ${(props) => props.borderBottom ?? "1px solid #d9d9d9"};
`;

export const POInfoRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FlexEndButtonWrapper = styled.div`
  justify-content: flex-end;
`;
export const FlexStartButtonWrapper = styled.div`
  justify-content: flex-start;
`;

export const ApiErrorText = styled.div`
  color: red;
  font-family: Lato;
  font-size: 0.875rem;
  margin-right: 15px;
`;